import styled from 'styled-components'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from '~/i18n'
import Text from '~/components/UI/Text'
import { HEADER_HEIGHT, COLORS } from '~/components/UI/Constants'
import SharedTitle from '~/components/UI/SharedTitle'
import Box from '~/components/UI/Box'
import Icon from '~/components/UI/Icon'
import appendCDN from '~/utils/append_cdn_link'
import { useState, useEffect, useCallback } from 'react'
import breakpoints from '~/components/UI/breakpoints'
import gsap from '~/modules/gsap'

const MyContainer = styled(Container)`
  padding-top: ${HEADER_HEIGHT + 20}px;
  background-color: #f9fafc;
  ${breakpoints.lg} {
    padding-top: ${HEADER_HEIGHT + 81}px;
  }
`

const Content = styled.div`
  > p {
    text-align: center;
    opacity: 0;
    transform: translateY(10px);
    ${breakpoints.md} {
      text-align: left;
    }
  }
`

const StyledIcon = styled(Icon)`
  font-size: 64px;
  ::before {
    color: ${COLORS.PRIMARY}
  }
`

const ArrowIcon = styled(Icon)`
  position: relative;
  font-size: 10px;
`

const PlayIcon = styled.span`
  height: 50px;
  width: 60px;
  background-color: rgba(26, 26, 26, 0.7);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Player = styled.div`
  background: url(${appendCDN('/img/video-thumnail.jpg')});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  position: relative;
  overflow: hidden;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  width: 350px;
  height: calc(350px * 9/16);
  top: 50%;
  transform: translateY(-50%);
  ::before {
    content: '';
    background-color:  rgba(26, 26, 26, 0.4);
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  ${breakpoints.md} {
    top: 0;
    transform: none;
  }
  ${breakpoints.lg} {
    width: 500px;
    height: calc(500px * 9/16);
  }
`

const ContentBox = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-direction: column;
  ${breakpoints.md} {
    height: 100%;
  }
`

const ArrowContainer = styled.div`
  text-align: center;
  height: 80px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  >span {
    transform: rotate(90deg);
    position: absolute;
  }
  ${breakpoints.md} {
    position: absolute;
    bottom: 0%;
    right: -25px;
    display: flex;
    display: block;
    height: auto;
    >span {
      transform: none;
      position: relative;
    }
  }
`

const HalfArrowIconContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 25%;
  ${breakpoints.md} {
    display: none;
  }
`

const HalfRoundArrowIcon = styled(Icon)`
  font-size: 80px;
`

const ArrowContainerStep2 = styled(ArrowContainer)`
  visibility: hidden;
  ${breakpoints.md} {
    visibility: visible;
  }
`

const What = () => {
  const [t] = useTranslation()
  const [playVideo, setPlayVideo] = useState(false)
  const onClickPlay = (evt: any) => {
    evt.preventDefault()
    setPlayVideo(true)
  }


  const initAnimations = useCallback(() => {

    gsap.to('#hiw-content > p', {
      stagger: 0.5,
      duration: 0.32,
      opacity: 1,
      y: 0
    })

    gsap.to('.hiw-content-box', {
      delay: 1.5,
      stagger: 0.3,
      duration: 0.25,
      opacity: 1,
      y: 0
    })

  }, [])


  useEffect(() => {
    setTimeout(() => {
      initAnimations()
    }, 500);
  }, [initAnimations])

  return (
    <MyContainer fluid>
      <Container style={{ padding: 0 }}>
        <Row>
          <Col className='mb-5' md={6}>
            <Content id='hiw-content'>
              <SharedTitle bold>
                {t`Đầu tư chung bất động sản là gì?`}
              </SharedTitle>
              <Text padding='24px 0'>
                {t`Đầu tư chung bất động sản là hình thức nhiều người cùng đầu tư và chia sẻ lợi nhuận từ một bất động sản (căn hộ, nhà phố, shophouse, ...). Với Infina, khách hàng có thể đầu tư một bất động sản tiềm năng chỉ với số tiền nhỏ một cách an toàn và tiện lợi`}
              </Text>
              <Text>
                {t`Các bất động sản được đánh giá và lựa chọn một cách khách quan bởi đội ngũ chuyên gia, đảm bảo các yếu tố tiềm năng sinh lời, an toàn pháp lý, chủ đầu tư uy tín`}
              </Text>
            </Content>
          </Col>
          <Col md={6} style={{ textAlign: 'center' }}>
            <Player>
              {playVideo && <iframe
                width="100%"
                height='100%'
                style={{ zIndex: 2 }}
                src='https://www.youtube.com/embed/HHddbnpdO9U?autoplay=1'
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen></iframe>}
              <a style={{ textDecoration: 'none', zIndex: 1, display: playVideo ? 'none' : 'block' }} onClick={onClickPlay} href='#'>
                <PlayIcon>
                  <Icon style={{ fontSize: 22 }} name='Play' />
                </PlayIcon>
              </a>
            </Player>
          </Col>
        </Row>
        <Box padding='64px 0'>
          <Text padding='0 0 56px 0' style={{ width: '100%' }} centered size={32} bold>
            {t`Quy trình mua và chốt lời`}
          </Text>
          <Row className="justify-content-md-center">
            <Col md={3}>
              <ContentBox className='animation-hide hiw-content-box'>
                <StyledIcon name='booking' />
                <Text centered padding='16px 0 0 0' bold size={18}>
                  {t`Mua “Phần sở hữu”`}
                </Text>
              </ContentBox>
              <ArrowContainer>
                <span>
                  <ArrowIcon name='straight-arrow-' />
                </span>
              </ArrowContainer>
            </Col>
            <Col md={3}>
              <HalfArrowIconContainer>
                <HalfRoundArrowIcon name='Line-arrow' />
              </HalfArrowIconContainer>
              <HalfArrowIconContainer
                style={{
                  transform: 'rotate(180deg)',
                  left: 'inherit',
                  right: '25%'
                }}>
                <HalfRoundArrowIcon name='Line-arrow' />
              </HalfArrowIconContainer>
              <ContentBox className='animation-hide hiw-content-box'>
                <StyledIcon name='pay-installment' />
                <Text centered padding='16px 0 0 0' bold size={18}>
                  {t`Đóng tiến độ`}
                </Text>
              </ContentBox>
              <ArrowContainerStep2
                style={{
                  justifyContent: 'space-between'
                }}>
                <ArrowIcon style={{
                  transform: 'rotate(180deg)',
                  position: 'absolute',
                  top: -8,
                }} name='straight-arrow-' />
                <ArrowIcon
                  style={{
                    position: 'relative',
                  }}
                  name='straight-arrow-' />
              </ArrowContainerStep2>
            </Col>
            <Col md={3}>
              <ContentBox className='animation-hide hiw-content-box'>
                <StyledIcon name='profit' />
                <Text centered padding='16px 0 0 0' bold size={18}>
                  {t`Nhận lợi nhuận`}
                </Text>
              </ContentBox>
              <ArrowContainer>
                <span>
                  <ArrowIcon name='straight-arrow-' />
                </span>
              </ArrowContainer>
            </Col>
            <Col md={3}>
              <ContentBox className='animation-hide hiw-content-box'>
                <StyledIcon name='capital' />
                <Text centered padding='16px 0 0 0' bold size={18}>
                  {t`Bán ra chốt lời`}
                </Text>
              </ContentBox>
            </Col>
          </Row>
        </Box>
      </Container>
    </MyContainer>
  )
}

export default What
